import { EditIcon, SearchIcon, SmallCloseIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useToast,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import { useState } from "react";
import ReactSearchBox from "react-search-box";

// let wordLimit = 500;

const SearchModal = ({
  lotNo,
  bin,
  valuesForLot,
  idx,
  enableEdit,
  setBinStatusData,
}) => {
  const toast = useToast();
  const [searchStatus, setSearchstatus] = useState(false);
  const [searchinput, setSearchInput] = useState(lotNo);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);

  // console.log(valuesForLot);
  const searchData = valuesForLot.map((item) => {
    return {
      value: item,
    };
  });

  const uniqueSearchData = Array.from(
    new Set(searchData.map((item) => item.value))
  ).map((value) => {
    return {
      value,
    };
  });

  // console.log(uniqueSearchData);
  const addLotNo = () => {
    if (searchinput) {
      // setData((prevDataArray) => {
      //   // Find the index of the item with the given idx in the array
      //   // const itemIndex = prevDataArray.findIndex((item) => item.idx === idx);
      //   // If the item is found, create a new array with the updated item
      //   if (itemIndex !== -1) {
      //     const updatedArray = [...prevDataArray];
      //     updatedArray[itemIndex] = {
      //       ...prevDataArray[itemIndex],
      //       lotNumber: searchinput,
      //     };
      //     return updatedArray;
      //   }

      //   // If the item is not found, return the original array
      //   return prevDataArray;
      // });
      setBinStatusData((prev) => {
        let updatedData = {
          ...prev,
          [idx]: {
            ...prev[idx],
            lotno: searchinput,
          },
        };
        return updatedData;
      });
      onClose();
    } else {
      toast({
        title: "Select Lot Number",
        status: "error",
        position: "top-right",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <div
        className={` flex justify-center items-center gap-2  `}
        onClick={() => {
          if (enableEdit) {
            onOpen();
          }
        }}
      >
        {lotNo ? (
          <EditIcon
            className={`cursor-pointer ${
              enableEdit ? "cursor-pointer" : "cursor-not-allowed"
            } `}
          />
        ) : (
          <SearchIcon
            className={`cursor-pointer ${
              enableEdit ? "cursor-pointer" : "cursor-not-allowed"
            } `}
          />
        )}
      </div>

      <Modal isOpen={isOpen} onClose={onClose} isCentered="true">
        <ModalOverlay />
        <ModalContent
          style={{ borderRadius: "12px" }}
          h={"400px"}
          overflow={"scroll"}
        >
          <div className=" flex justify-end p-2 text-[#79767D]">
            {" "}
            <SmallCloseIcon onClick={onClose} className="cursor-pointer" />
          </div>
          <ModalBody pos="relative" p="12px" rounded="12px">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col relative gap-2">
                <p className="text-[#79767D] text-[14px]">Bin {bin}</p>
              </div>
              <div>
                <ReactSearchBox
                  placeholder={lotNo ? lotNo : "Search Lot No."}
                  data={uniqueSearchData}
                  value={searchinput}
                  onSelect={(e) => {
                    setSearchInput(e.item.value);
                    setSearchstatus(true);
                  }}
                />
              </div>
              <div className="flex justify-end">
                {loading ? (
                  <button className="text-white py-3 px-4 rounded-[100px] bg-[#084298] text-base font-medium w-[50%] hover:opacity-60">
                    <Spinner />
                  </button>
                ) : (
                  <button
                    className="text-white py-3 px-4 rounded-[100px] bg-[#1a174e] text-base font-medium w-[150px] hover:opacity-60"
                    onClick={() => {
                      addLotNo();
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SearchModal;
